import { useState, useContext } from "react";
import ExperienceContext from "./ExperienceContext";
import { Group, Button, Textarea, Modal } from "@mantine/core";
import { showErrorNotification } from "../../utils/Notifications";
function InfospotModal({ isInfoSpotOpen, setIsInfoSpotOpen, activePanoId }) {
	const { addNewTextspot } = useContext(ExperienceContext);
	const [infoText, setInfoText] = useState("");
	const handleCreate = () => {
		if (infoText === "") {
			showErrorNotification("Text cannot be empty");
			return;
		}
		addNewTextspot(activePanoId, infoText);
		setInfoText("");
		setIsInfoSpotOpen(false);
	};
	return (
		<Modal
			centered
			size='lg'
			opened={isInfoSpotOpen}
			onClose={() => {
				setIsInfoSpotOpen(false);
				setInfoText("");
			}}
			title='Add Info Spot'
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			}}
		>
			<Textarea
				data-autofocus
				placeholder='Enter spot information here'
				required
				styles={{
					input: { backgroundColor: "#040F1F", border: "1px solid #09254E" },
				}}
				value={infoText}
				onChange={(e) => setInfoText(e.target.value)}
			/>
			<Group style={{ width: "100%", justifyContent: "end" }}>
				<Button
					variant='outline'
					my={10}
					px={30}
					size='xs'
					radius={"md"}
					sx={(theme) => ({
						color: theme.colors.white[0],
						borderColor: theme.colors.ivisit_light[0],
					})}
					onClick={() => {
						setInfoText("");
						setIsInfoSpotOpen(false);
					}}
				>
					Cancel
				</Button>
				<Button
					variant='outline'
					my={10}
					px={30}
					size='xs'
					radius={"md"}
					sx={(theme) => ({
						color: theme.colors.white[0],
						borderColor: theme.colors.ivisit_light[0],
					})}
					onClick={handleCreate}
				>
					Create
				</Button>
			</Group>
		</Modal>
	);
}

export default InfospotModal;
